module.exports = __webpack_public_path__ + "static/media/medium-well.6a35959d.png";